interface ToastProps {
  message: string;
  onClose: () => void;
}

export function Toast({ message, onClose }: ToastProps) {
  return (
    <div className="toast" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
      <span style={{ fontSize: '0.875rem' }}>{message}</span>
      <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
    </div>
  );
}